import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg, { getOrganizationSchema, getWebSiteSchema, getWebPageSchema } from '@/components/feature/SchemaOrg';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Home() {
  const featuredArticles = articles.filter((a) => a.featured);
  const latestArticles = articles.slice(0, 6);

  return (
    <>
      <SEOHead
        title="开云体育网址官方入口·快速直达"
        description="开云体育网址是广大体育竞技爱好者的首选平台，提供最新官方网址直达入口、安全登录通道及完整体育赛事服务。本页汇聚开云体育网址使用指南、注册流程、活动福利及常见问题解答，帮助用户快速找到正确网址并畅享体育娱乐体验。"
        keywords="开云体育网址,开云体育官方网址,开云体育网址入口,开云体育网址登录,开云体育最新网址,开云体育网址注册,开云体育平台网址"
        canonicalUrl="https://www.kaiyunsports.com/"
        ogTitle="开云体育网址官方入口·快速直达"
        ogDescription="开云体育网址是广大体育竞技爱好者的首选平台，提供最新官方网址直达入口、安全登录通道及完整体育赛事服务。"
        ogUrl="https://www.kaiyunsports.com/"
      />
      <SchemaOrg {...getOrganizationSchema()} />
      <SchemaOrg {...getWebSiteSchema()} />
      <SchemaOrg {...getWebPageSchema('开云体育网址官方入口·快速直达', siteInfo.description, 'https://www.kaiyunsports.com/')} />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20panorama%20with%20warm%20golden%20sunset%20lighting%2C%20athletes%20silhouettes%20in%20motion%2C%20dramatic%20clouds%2C%20energetic%20atmosphere%2C%20wide%20angle%20architectural%20view%2C%20professional%20sports%20photography%2C%20rich%20amber%20and%20gold%20tones%2C%20epic%20scale&width=1800&height=1200&seq=home-hero-2026&orientation=landscape"
              alt="开云体育 - 体育竞技平台"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
              开云体育网址官方入口
              <span className="block text-xl md:text-2xl font-normal mt-2 text-background-50/90">畅享体育精彩，尽在开云体育</span>
            </h1>
            <p className="text-sm md:text-base text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/platform-guide"
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors whitespace-nowrap text-sm"
              >
                <i className="ri-guide-line mr-2"></i>查看平台指南
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-lg backdrop-blur-sm transition-colors whitespace-nowrap text-sm border border-background-50/20"
              >
                <i className="ri-information-line mr-2"></i>了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Stats Bar */}
        <section className="bg-primary-500">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</div>
                  <div className="text-xs md:text-sm text-background-50/80 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-14 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">内容导航</h2>
              <p className="text-sm text-foreground-500 mt-2">选择您感兴趣的内容分类，快速找到所需信息</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all text-center"
                >
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm">{cat.name}</h3>
                  <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed">{cat.description}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-14 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">精选文章</h2>
                <p className="text-sm text-foreground-500 mt-2">编辑推荐的高质量内容</p>
              </div>
              <Link to="/category/sports-news" className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap">
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {featuredArticles.map((article) => (
                <Link key={article.id} to={`/article/${article.id}`} className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all">
                  <div className="relative h-48 overflow-hidden">
                    <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-md">{article.category}</span>
                  </div>
                  <div className="p-5">
                    <h3 className="font-heading font-semibold text-foreground-900 text-sm leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">{article.title}</h3>
                    <p className="text-xs text-foreground-500 mt-2 leading-relaxed line-clamp-2">{article.excerpt}</p>
                    <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/60">
                      <span className="text-xs text-foreground-400">{article.date}</span>
                      <span className="text-xs text-primary-600 font-medium flex items-center gap-1">阅读全文 <i className="ri-arrow-right-line text-xs"></i></span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="py-14 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">最新文章</h2>
                <p className="text-sm text-foreground-500 mt-2">最新发布的内容</p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group flex gap-4 p-4 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all"
                >
                  <div className="w-24 h-24 flex-shrink-0 rounded-lg overflow-hidden">
                    <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded mb-1.5">{article.category}</span>
                    <h3 className="font-heading font-medium text-foreground-900 text-sm leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">{article.title}</h3>
                    <p className="text-xs text-foreground-400 mt-1.5">{article.date}</p>
                  </div>
                </Link>
              ))}
            </div>
            <div className="text-center mt-8">
              <Link
                to="/category/platform-guide"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap"
              >
                浏览全部文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Platform Features */}
        <section className="py-14 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">为什么选择开云体育</h2>
              <p className="text-sm text-foreground-500 mt-2">六大核心优势，打造极致体育体验</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {siteInfo.features.map((feature) => (
                <div key={feature.title} className="p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all">
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                    <i className={`${feature.icon} text-lg`}></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2">{feature.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-16 md:py-20 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Sports%20arena%20with%20dramatic%20stadium%20lights%2C%20warm%20golden%20atmosphere%2C%20sports%20fans%20celebration%2C%20energetic%20crowd%2C%20blurred%20motion%2C%20dramatic%20lighting%20effects%2C%20professional%20sports%20event%20atmosphere&width=1600&height=800&seq=home-cta-2026&orientation=landscape"
              alt="开云体育平台"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">准备好开始您的体育之旅了吗？</h2>
            <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto mb-7">立即访问开云体育官方网址，畅享海量赛事与丰厚福利</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/platform-guide"
                className="px-8 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-medium rounded-lg transition-colors whitespace-nowrap text-sm"
              >
                <i className="ri-rocket-line mr-2"></i>快速上手
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-lg backdrop-blur-sm transition-colors whitespace-nowrap text-sm border border-background-50/20"
              >
                <i className="ri-customer-service-2-line mr-2"></i>了解更多
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}